import React, { Component } from 'react';
import { Helmet } from "react-helmet";

import { Form, Field } from 'react-final-form';
import { Button, TextArea } from "grommet";
import LoginComponent from "../../components/Login";

class SettingsPage extends Component {

  constructor() {
    super();
    this.state = {
      module: 'Events',
      secdim: 'eventAction',
    };
    this.setLogin = this.setLogin.bind(this);
    this.updateBlob = this.updateBlob.bind(this);
    this.account = "analyticsdiag870";
    this.blob = "setting.json";
    this.container = "mdsettingsandexperiments";
  }

  async setLogin() {

    const { BlobServiceClient } = await import(/* webpackChunkName: "@azure/storage-blob" */ '@azure/storage-blob');

    // Enter your storage account name
    const defaultAzureCredential = this.props.defaultAzureCredential;
    const blobServiceClient = new BlobServiceClient(
      `https://${this.account}.blob.core.windows.net`,
      defaultAzureCredential
    );
    const containerClient = blobServiceClient.getContainerClient(this.container);
    this.containerClient = containerClient;
    const blockBlobClient = containerClient.getBlockBlobClient(this.blob);
    const downloadBlockBlobResponse = await blockBlobClient.download(0);
    const blob = await downloadBlockBlobResponse.blobBody;
    const token = await blob.text();

    this.setState({ token });
  }

  async updateBlob({ json:  content }) {
    if(!this.containerClient) {
      return;
    }
    console.log({ json:  content })
    const blockBlobClient = this.containerClient.getBlockBlobClient(this.blob);
    const uploadBlobResponse = await blockBlobClient.upload(content, content.length);
    this.setState({ token: content });
    console.log(`Upload block blob ${this.blob} successfully`, uploadBlobResponse.requestId);
  }

  componentDidMount() {
    if(!this.state.token) {
      this.setLogin();
    }
  }

  render() {

    return !this.state.token ? (<div>
      <p>Loading...</p>
    </div>) : (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Runtime settings - MD Dashboard</title>
        </Helmet>
        <Form
          onSubmit={this.updateBlob}
          validate={() => true}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Field
                name="json"
                validate={value => {
                  try {
                    JSON.parse(value);
                    return undefined;
                  } catch(e) {
                    return "Value must be a JSON string!";
                  }
                }}
                initialValue={this.state.token}
                render={({ input, meta }) => (
                  <div>
                    <TextArea
                      {...input}
                      onChange={event => input.onChange(event.target.value)}
                    />
                    {meta.touched && meta.error && <span>{meta.error}</span>}
                  </div>
                )}
              />
              <button type="submit">Submit</button>
            </form>)}
        />



        <pre>{JSON.stringify(this.state.token, null, "  ")}</pre>
      </div>
    );
  }
}

export default () => {
  return <LoginComponent>{({ defaultAzureCredential }) => (<SettingsPage defaultAzureCredential={defaultAzureCredential} />)}</LoginComponent>
}
